const RouteState = { render: () => null };

export const AGENT_PAGES_ROUTES = [
  { path: 'agent-pages', name: 'AdminAgentPages', component: RouteState, meta: { adminTab: 'Agent Pages' } },
  { path: 'agent-pages/:id(\\d+)', name: 'AdminAgentPageEdit', component: RouteState, meta: { adminTab: 'Agent Pages' } },
];
